import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { ColumnContainerComponent } from './layout/column-container/column-container.component';
import { ProgressTrackerComponent } from './layout/progress-tracker/progress-tracker.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptor } from './interceptor/request.interceptor';

@NgModule({
	declarations: [
		ColumnContainerComponent,
		ProgressTrackerComponent,
		HeaderComponent,
		FooterComponent
	],
	imports: [CommonModule, SharedModule],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RequestInterceptor,
			multi: true
		}
	],
	exports: [
		ColumnContainerComponent,
		ProgressTrackerComponent,
		HeaderComponent,
		FooterComponent
	]
})
export class CoreModule {}
